import React, { useContext, useEffect, useRef } from 'react';
import { COLLAPSE_ANIMATION_DURATION, WIDTHS } from '../../AppNavigator/TabNavigation/DrawerNavigation/constants';
import Images from '../../../Images';
import { Animated, Image, Platform } from 'react-native';
import { getIntl } from '../../../utils/intl';
import { SideDrawerCollapsedStateContext } from '../SideDrawerCollapsedStateProvider';
import { useDrawerWidthAnimation } from '../../AppNavigator/TabNavigation/DrawerNavigation/useDrawerWidthAnimation';

const intl = getIntl('DrawerHeaderImage', {
    headerImageAlt: 'Header Primary Record Logo',
});

export type DrawerHeaderImageOwnProps = {};

export type DrawerHeaderImageProps = DrawerHeaderImageOwnProps;

const HEIGHT = 80;
const IMAGE_HEIGHT = 25;
const PADDING_X = 4;
const PADDING_Y = (HEIGHT - IMAGE_HEIGHT) / 2;

const DrawerHeaderImage: React.FC<DrawerHeaderImageProps> = (_props) => {
    const { isCollapsed } = useContext(SideDrawerCollapsedStateContext);
    const widthAnimation = useDrawerWidthAnimation(isCollapsed);
    const largeLogoOpacityAnimation = useRef<Animated.Value>(new Animated.Value(isCollapsed ? 0 : 1));
    useEffect(() => {
        if (!largeLogoOpacityAnimation.current) return;

        Animated.timing(largeLogoOpacityAnimation.current, {
            toValue: isCollapsed ? 0 : 1,
            duration: COLLAPSE_ANIMATION_DURATION,
            useNativeDriver: Platform.OS === 'web',
        }).start();
    }, [isCollapsed]);

    return (
        <Animated.View
            style={{
                width: widthAnimation.current,
                height: HEIGHT,
                paddingHorizontal: PADDING_X,
                paddingVertical: PADDING_Y,
                overflow: 'hidden',
            }}
        >
            <Animated.View
                style={{
                    position: 'absolute',
                    top: PADDING_Y,
                    left: 12,
                    width: WIDTHS.expanded - 28,
                    opacity: largeLogoOpacityAnimation.current,
                }}
            >
                <Image
                    alt={intl('headerImageAlt')}
                    style={{
                        width: 173,
                        height: IMAGE_HEIGHT,
                    }}
                    resizeMode={'contain'}
                    defaultSource={Images.LargeHeaderLogo}
                    source={Images.LargeHeaderLogo}
                />
            </Animated.View>
            <Animated.View
                style={{
                    position: 'absolute',
                    top: PADDING_Y,
                    left: 12,
                    width: 30,
                }}
            >
                <Image
                    alt={intl('headerImageAlt')}
                    style={{
                        width: IMAGE_HEIGHT,
                        height: IMAGE_HEIGHT,
                    }}
                    resizeMode={'contain'}
                    defaultSource={Images.SmallHeaderLogo}
                    source={Images.SmallHeaderLogo}
                />
            </Animated.View>
        </Animated.View>
    );
};

export default React.memo(DrawerHeaderImage);
